import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableBroadcastTemplateRoutes = Loadable(
  './BroadcastTemplateRoutes',
  () => import(/* webpackChunkName: "BroadcastTemplate" */ './BroadcastTemplateRoutes'),
  () => [(require as any).resolveWeak('./BroadcastTemplateRoutes')]
);
